import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from '@mui/material'
import { formatCurrencyShortForm } from '@/utils/storage'

interface MediaArticleData {
  media: string
  total: number
}

interface Props {
  data: MediaArticleData[]
  isLocked: boolean
}

const TotalArticleByMediaTable = ({ data, isLocked }: Props) => {
  return (
    <TableContainer component={Paper} style={{ width: '100%', maxHeight: '300px', overflow: 'auto', borderRadius: 8 }}>
      <Table
        size="small"
        sx={{ width: '100%', tableLayout: 'fixed' }}
        aria-label="total article by media table"
        stickyHeader
      >
        <TableHead
          sx={{
            backgroundColor: 'rgba(223, 202, 114, 1)',
            height: 10,
          }}
        >
          <TableRow
            sx={{
              height: 10,
              backgroundColor: 'rgba(223, 202, 114, 1)',
              '& .MuiTableCell-head': {
                backgroundColor: 'rgba(223, 202, 114, 1)',
                lineHeight: 1.5,
              },
            }}
          >
            <TableCell>No</TableCell>
            <TableCell align="left">Media</TableCell>
            <TableCell align="center">Total</TableCell>
          </TableRow>
        </TableHead>
        <TableBody
          sx={{
            ...(isLocked
              ? {
                  filter: 'blur(4px)',
                  transform: 'translateZ(0)',
                }
              : {}),
          }}
        >
          {data.map((row, index) => (
            <TableRow
              key={index}
              sx={{
                '&:last-child td, &:last-child th': { border: 0 },
                '& .MuiTableCell-body': {},
              }}
            >
              <TableCell component="th" scope="row">
                {index + 1}
              </TableCell>
              <TableCell align="left">
                <Typography variant="body2">{row.media}</Typography>
              </TableCell>
              <TableCell align="center">
                <Tooltip title={Number(row.total).toLocaleString('id-ID')} arrow placement="bottom-start">
                  <Typography variant="body2">{formatCurrencyShortForm(row.total)}</Typography>
                </Tooltip>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default TotalArticleByMediaTable
